var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("ProductCartView"),
      _vm._v(" "),
      _c("div", { staticClass: "battery-store__nav-row h-center-align" }, [
        _c(
          "button",
          {
            staticClass: "btn btn-primary",
            on: {
              click: function($event) {
                $event.preventDefault()
                return _vm.addProducts($event)
              }
            }
          },
          [_vm._v("Add Additional Products")]
        )
      ]),
      _vm._v(" "),
      _vm._m(0),
      _vm._v(" "),
      _c("div", { staticClass: "panel" }, [
        _c("div", { staticClass: "css-grid battery-order-form__row" }, [
          _c("div"),
          _vm._v(" "),
          _c("div", [
            _c("p", { staticClass: "h-italic-text h-center-align" }, [
              _vm._v("All fields with * are required.")
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "form__item--row" },
              [
                _c("StoreConnectedInput", {
                  attrs: {
                    store: _vm.store,
                    action: _vm.action,
                    "sub-prop": "company",
                    name: "shippingInfo",
                    callback: "batteryStore/touchLocationInfo",
                    placeholder: "Company Name *"
                  }
                })
              ],
              1
            )
          ]),
          _vm._v(" "),
          _c("div")
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "css-grid battery-order-form__row" }, [
          _c("div"),
          _vm._v(" "),
          _c("div", [
            _c(
              "div",
              { staticClass: "form__item--row" },
              [
                _c("StoreConnectedSelect", {
                  attrs: {
                    store: _vm.store,
                    name: "selectedShippingLocationID",
                    options: _vm.locations,
                    "options-value": "id",
                    "options-label": "address_label",
                    callback: "batteryStore/setLocationInfo",
                    placeholder: "Select Location *"
                  }
                })
              ],
              1
            )
          ]),
          _vm._v(" "),
          _c("div")
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "css-grid battery-order-form__row" }, [
          _c("div"),
          _vm._v(" "),
          _c("div", [
            _c("div", { staticClass: "grid__col--6" }, [
              _c(
                "div",
                { staticClass: "form__item--row" },
                [
                  _c("StoreConnectedInput", {
                    attrs: {
                      store: _vm.store,
                      action: _vm.action,
                      "sub-prop": "first_name",
                      name: "shippingInfo",
                      callback: "batteryStore/touchLocationInfo",
                      placeholder: "First Name *"
                    }
                  })
                ],
                1
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "grid__col--6" }, [
              _c(
                "div",
                { staticClass: "form__item--row" },
                [
                  _c("StoreConnectedInput", {
                    attrs: {
                      store: _vm.store,
                      action: _vm.action,
                      "sub-prop": "last_name",
                      name: "shippingInfo",
                      callback: "batteryStore/touchLocationInfo",
                      placeholder: "Last Name *"
                    }
                  })
                ],
                1
              )
            ])
          ]),
          _vm._v(" "),
          _c("div")
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "css-grid battery-order-form__row" }, [
          _c("div"),
          _vm._v(" "),
          _c("div", [
            _c("div", { staticClass: "grid__col--6" }, [
              _c(
                "div",
                { staticClass: "form__item--row" },
                [
                  _c("StoreConnectedInput", {
                    attrs: {
                      store: _vm.store,
                      action: _vm.action,
                      "sub-prop": "email",
                      name: "shippingInfo",
                      callback: "batteryStore/touchLocationInfo",
                      placeholder: "Email *"
                    }
                  })
                ],
                1
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "grid__col--6" }, [
              _c(
                "div",
                { staticClass: "form__item--row" },
                [
                  _c("StoreConnectedInput", {
                    attrs: {
                      store: _vm.store,
                      action: _vm.action,
                      "sub-prop": "phone",
                      name: "shippingInfo",
                      callback: "batteryStore/touchLocationInfo",
                      placeholder: "Telephone *"
                    }
                  })
                ],
                1
              )
            ])
          ]),
          _vm._v(" "),
          _c("div")
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "css-grid battery-order-form__row" }, [
          _c("div"),
          _vm._v(" "),
          _c("div", [
            _c("div", { staticClass: "grid__col--8" }, [
              _c(
                "div",
                { staticClass: "form__item--row" },
                [
                  _c("StoreConnectedInput", {
                    attrs: {
                      store: _vm.store,
                      action: _vm.action,
                      "sub-prop": "street",
                      name: "shippingInfo",
                      callback: "batteryStore/touchLocationInfo",
                      placeholder: "Street *"
                    }
                  })
                ],
                1
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "grid__col--4" }, [
              _c(
                "div",
                { staticClass: "form__item--row" },
                [
                  _c("StoreConnectedInput", {
                    attrs: {
                      store: _vm.store,
                      action: _vm.action,
                      "sub-prop": "street_2",
                      name: "shippingInfo",
                      placeholder: "Street 2"
                    }
                  })
                ],
                1
              )
            ])
          ]),
          _vm._v(" "),
          _c("div")
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "css-grid battery-order-form__row" }, [
          _c("div"),
          _vm._v(" "),
          _c("div", [
            _c("div", { staticClass: "grid__col--6" }, [
              _c(
                "div",
                { staticClass: "form__item--row" },
                [
                  _c("StoreConnectedInput", {
                    attrs: {
                      store: _vm.store,
                      action: _vm.action,
                      "sub-prop": "city",
                      name: "shippingInfo",
                      callback: "batteryStore/touchLocationInfo",
                      placeholder: "City *"
                    }
                  })
                ],
                1
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "grid__col--3" }, [
              _c(
                "div",
                { staticClass: "form__item--row" },
                [
                  _c("StoreConnectedSelect", {
                    attrs: {
                      store: _vm.store,
                      action: _vm.action,
                      "sub-prop": "state",
                      name: "shippingInfo",
                      callback: "batteryStore/touchLocationInfo",
                      options: _vm.states,
                      placeholder: "State *"
                    }
                  })
                ],
                1
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "grid__col--3" }, [
              _c(
                "div",
                { staticClass: "form__item--row" },
                [
                  _c("StoreConnectedInput", {
                    attrs: {
                      store: _vm.store,
                      action: _vm.action,
                      "sub-prop": "zip",
                      name: "shippingInfo",
                      callback: "batteryStore/touchLocationInfo",
                      placeholder: "Zip Code *"
                    }
                  })
                ],
                1
              )
            ])
          ]),
          _vm._v(" "),
          _c("div")
        ])
      ])
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass:
          "css-grid battery-order-form__row battery-order-form__row--header"
      },
      [
        _c("div"),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass:
              "battery-order-view__cell battery-order-view__cell--header"
          },
          [_vm._v("Shipping Info")]
        ),
        _vm._v(" "),
        _c("div")
      ]
    )
  }
]
render._withStripped = true

export { render, staticRenderFns }